const ACCESS_TOKEN_KEY = 'drivio_access_token';

const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

const setAccessToken = (token) => {
  if (!token) {
    return;
  }

  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

const clearAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);

export { getAccessToken, setAccessToken, clearAccessToken };
